import { render, staticRenderFns } from "./send-success.vue?vue&type=template&id=f04cca8e&scoped=true&"
import script from "./send-success.vue?vue&type=script&lang=js&"
export * from "./send-success.vue?vue&type=script&lang=js&"
import style0 from "./send-success.vue?vue&type=style&index=0&id=f04cca8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04cca8e",
  null
  
)

export default component.exports